import type { ReactNode } from "react"
import Icon from "@/v1-ui/Icon"
import type { IconProps } from "@/v1-ui/Icon"
import Popover from "./Popover"
import type { PopoverProps } from "./Popover"

export type TipoverProps = PopoverProps & {
  iconSrc?: IconProps["src"],
  iconSize?: IconProps["size"],
  iconClassName?: IconProps["className"],
  iconStyle?: IconProps["style"],
  children?: ReactNode
}

function Tipover(props: TipoverProps) {
  const {
    role = "tooltip",
    iconSrc = "interrogation",
    iconSize,
    iconClassName,
    iconStyle,
    children,
    ...popoverProps
  } = props

  return (
    <Popover
      role={role}
      {...popoverProps}
    >
      {children}

      <Icon
        src={iconSrc}
        size={iconSize}
        className={iconClassName}
        style={iconStyle}
        aria-label="Mer info"
      />
    </Popover>
  )
}

export default Tipover
